<template>
  <div
    data-testid="container-main"
    class="container"
    :class="[
      `container--${type}`,
      {
        'container--no-padding': noPadding,
        'container--mobile-no-padding': mobileNoPadding,
        'container--indent-bottom': indentBottom
      }
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ContainerMain',
  props: {
    noPadding: {
      type: Boolean,
      default: false
    },
    mobileNoPadding: {
      type: Boolean,
      default: false
    },
    indentBottom: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    type: {
      type: [String, Object],
      default: null,
      validator(value) {
        return ['sm', 'lg'].includes(value)
      }
    }
  }
}
</script>
